import { Icon } from 'components/ui/Icon'
import { CitationSource } from 'types/chat-message'

type AttachmentCitationProps = {
  num: string
  source?: CitationSource
}

/**
 * Inline citation for a user-uploaded document ([att:N]): a paperclip pill that
 * sets it apart from remote sources, linking out when the source carries a url.
 */
export const AttachmentCitation = ({ num, source }: AttachmentCitationProps) => {
  const badge = (
    <span
      className="tw-inline-flex tw-items-center tw-gap-0.5 tw-align-super tw-mx-[1px] tw-rounded-full tw-px-1 tw-text-[10px] tw-font-bold"
      style={{ backgroundColor: 'var(--input-bg)', color: 'var(--text-muted)' }}
    >
      <Icon icon={['fas', 'paperclip']} className="tw-h-2.5 tw-w-2.5" />
      {num}
    </span>
  )

  if (source?.url) {
    return (
      <a href={source.url} target="_blank" rel="noopener noreferrer" title={source.name} className="tw-no-underline">
        {badge}
      </a>
    )
  }

  return <span title={source?.name}>{badge}</span>
}
